import type { SearchGroupResult } from "src/http/types";
import { useAppContext } from "src/shared/context/AppContext";
import { storeAnalyticsEvent } from "src/shared/utils/analyticsevent/analyticsevent-batcher";
import { formatTimestampForAnalytics } from "src/shared/utils/analyticsevent/utils";
import {
  PaddedWrapper,
  StyledCompactTopResultGrid,
} from "src/website-apps/responsive/stubhub-find/components/TopResults/styled-components";
import { TopResultCard } from "src/website-apps/responsive/stubhub-find/components/TopResults/TopResultCard";
import { SEARCH_CLICK_TYPES } from "src/website-apps/shared/utils/searchPageEvents";

interface TopResultData extends SearchGroupResult {
  subtitle?: string;
  iconName?: string;
}

interface TopResultPillsProps {
  topSearchResults: Maybe<TopResultData[]>;
}

export const TopResultPills = ({ topSearchResults }: TopResultPillsProps) => {
  const appContext = useAppContext();
  const { env } = appContext;
  return topSearchResults && topSearchResults.length > 0 ? (
    <PaddedWrapper $removeSideSpacing>
      <div style={{ height: "12px" }} />
      <StyledCompactTopResultGrid>
        {topSearchResults.map((result, idx) => (
          <li key={result.id ?? idx}>
            <TopResultCard
              id={result.id}
              imageUrl={result.searchGroupResultDetails?.imageUrl}
              onClick={() => {
                const p = [
                  {
                    anonymousId: appContext.anonymousId,
                    pageVisitId: appContext.pageVisitId,
                    userId: result.userId,
                    cobrandId: appContext.cobrandId,
                    currentUrl: appContext.currentUrl,
                    sessionId: appContext.sessionId,
                    entityType: result.searchGroupResultDetails?.entityType,
                    entityId: result.id,
                    position: result.rank ?? idx,
                    queryId: result.queryId,
                    invocationId: result.invocationId,
                    recordId: result.objectId,
                    indexName: result.indexName,
                    searchClickType: SEARCH_CLICK_TYPES.RESULT_CATEGORY,
                    clickDate: formatTimestampForAnalytics(),
                  },
                ];
                storeAnalyticsEvent(
                  {
                    applicationName: appContext.appName,
                    applicationVersion: appContext.appVersion,
                    eventName: "SearchResultClick",
                    eventBody: p[0],
                    insertTime: Date.now(),
                  },
                  env,
                );
              }}
              title={result.title}
              subtitle={result.subtitle}
              iconName={result.iconName}
              numberRelationships={result.numberRelationships}
              url={result.url}
              searchRedesign={false}
            />
          </li>
        ))}
      </StyledCompactTopResultGrid>
    </PaddedWrapper>
  ) : null;
};
